export const attemptAggregate = async (
  multicall,
  calls,
  attempts = 10,
  interval = 1000
) => {
  for (let i = 0; i < attempts; i++) {
    try {
      return await multicall.aggregate.staticCall(calls);
    } catch (error) {
      console.error(`Attempt ${i + 1} failed: `, error);

      if (i === attempts - 1) throw error;

      await new Promise(resolve => setTimeout(resolve, interval));
    }
  }
};